export const createUpdateGroupConstants = {
  GET_WORKPLACES_REQUEST: 'GROUP/GET_WORKPLACES_REQUEST',
  GET_WORKPLACES_SUCCESS: 'GROUP/GET_WORKPLACES_SUCCESS',
  GET_WORKPLACES_FAILURE: 'GROUP/GET_WORKPLACES_FAILURE',

  GET_GROUP_DETAIL_REQUEST: 'GROUP/GET_GROUP_DETAIL_REQUEST',
  GET_GROUP_DETAIL_SUCCESS: 'GROUP/GET_GROUP_DETAIL_SUCCESS',
  GET_GROUP_DETAIL_FAILURE: 'GROUP/GET_GROUP_DETAIL_FAILURE',

  SET_SELECTED_WORKPLACE: 'GROUP/SET_SELECTED_WORKPLACE',
  SET_GROUP_NAME: 'GROUP/SET_GROUP_NAME',
  SET_SKIP_PICTURE: 'GROUP/SET_SKIP_PICTURE',
  SET_GROUP_DESCRIPTION: 'GROUP/SET_GROUP_DESCRIPTION',
  SET_GROUP_LOCATION: 'GROUP/SET_GROUP_LOCATION',
  SET_GROUP_PICTURE: 'GROUP/SET_GROUP_PICTURE',
  SET_PRIVACY_SETTING: 'GROUP/SET_PRIVACY_SETTING',
  SET_LOCATION: 'GROUP/SET_LOCATION',
  SET_MIXR_SETTING: 'GROUP/SET_MIXR_SETTING',
  SET_AGE_SETTING: 'GROUP/SET_AGE_SETTING',
  SET_APPROVAL_SETTING: 'GROUP/SET_AGE_SET_APPROVAL_SETTINGSETTING',

  SELECT_INTERESTS: 'GROUP/SELECT_INTERESTS',

  SET_PRIVACY_SETTING: 'GROUP/SET_PRIVACY_SETTING',

  CREATE_GROUP_REQUEST: 'GROUP/CREATE_GROUP_REQUEST',
  CREATE_GROUP_SUCCESS: 'GROUP/CREATE_GROUP_SUCCESS',
  CREATE_GROUP_FAILURE: 'GROUP/CREATE_GROUP_FAILURE',

  EDIT_GROUP_REQUEST: 'GROUP/EDIT_GROUP_REQUEST',
  EDIT_GROUP_SUCCESS: 'GROUP/EDIT_GROUP_SUCCESS',
  EDIT_GROUP_FAILURE: 'GROUP/EDIT_GROUP_FAILURE',

  CAN_MEMBER_SUGGEST_MIXR: 'GROUP/CAN_MEMBER_SUGGEST_MIXR',
  SET_MEMBER_SETTING: 'GROUP/SET_MEMBER_SETTING',
  SET_GROUP_TYPE: 'GROUP/SET_GROUP_TYPE',
  SET_AUTO_APPROVAL_TO_JOIN: 'GROUP/SET_AUTO_APPROVAL_TO_JOIN',
  SET_MEMBER_AGE_SETTING: 'GROUP/SET_MEMBER_AGE_SETTING',
  SHOW_LOCATION: 'GROUP/SHOW_LOCATION',
  SHOW_INTERESTS: 'GROUP/SHOW_INTERESTS',
  SHOW_PICTURE_UPLOAD: 'GROUP/SHOW_PICTURE_UPLOAD',
  SHOW_ADV_SETTING: 'GROUP/SHOW_ADV_SETTING',
  SHOW_PRIVACY_SETTING: 'GROUP/SHOW_PRIVACY_SETTING',
  SHOW_DESCRIPTION: 'GROUP/SHOW_DESCRIPTION',
  SHOW_GROUP_NAME: 'GROUP/SHOW_GROUP_NAME',
  SHOW_GROUP_TYPE: 'GROUP/SHOW_GROUP_TYPE',
  SET_FORM_COMPLETED: 'GROUP/SET_FORM_COMPLETED',
  SET_VALIDATION_ERRORS: 'GROUP/SET_VALIDATION_ERRORS',
  CLEAR_ERRORS: 'GROUP/CLEAR_ERRORS',

  REMOVE_GROUP_PICTURE: 'GROUP/REMOVE_GROUP_PICTURE',
  SET_GROUP_PICTURE: 'GROUP/SET_GROUP_PICTURE',

  SET_AS_GENERAL_GROUP: 'GROUP/SET_AS_GENERAL_GROUP',
  CLEAR_DATA: 'GROUP/CLEAR_DATA'
}
